module.exports = __webpack_public_path__ + "img/icon-yearendmeeting.f399dfe1.svg";